import Button from '@platform-ui-common/components/Button/index.js';
import Popper from '@platform-ui-common/components/Popper/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import useLogout from '../../hooks/useLogout.js';

export interface LogOutPopperProps {
  onClickClose: () => void;
  isOpen: boolean;
  anchorEl?: HTMLButtonElement;
}

export function LogOutButton(): JSX.Element {
  const { logout, loading } = useLogout();

  return (
    <div>
      <Button id="logOutBtn" variant="text" disabled={loading} onClick={logout}>
        Log Out
      </Button>
    </div>
  );
}

export default function LogOutPopper({
  onClickClose,
  isOpen,
  anchorEl,
}: LogOutPopperProps): JSX.Element {
  return (
    <Popper isOpen={isOpen} onClickClose={onClickClose} anchorEl={anchorEl} title="Log Out">
      <div className="py-14 lg:py-4 lg:max-w-[15rem]">
        <Typography variant="body">
          Your progress will be saved through the last screen you finished.
        </Typography>
      </div>
      <div>
        <div>
          <Button variant="text" className="mb-2" onClick={onClickClose}>
            Keep Going
          </Button>
        </div>
        <LogOutButton />
      </div>
    </Popper>
  );
}
